export default {
  getAvailableFilters: (state) => state.availableFilters,
  getAvailableGlobalAmounts: (state) => state.availableGlobalAmounts,
  getExports: (state) => state.exports,
  getExport: (state) => (id) => {
    return state.exports.find(exp => exp.id === parseInt(id))
  },
  getExportsContext: (state) => state.exportsContext,
  // getEmptyExport: (state) => JSON.parse(JSON.stringify(state.emptyExport)),
}